module.exports = __webpack_public_path__ + "img/cloud_top.555a15e1.png";